import axios from "axios";
const BASE_URL = process.env.REACT_APP_WEB_URL;

const axiosCilent = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
});

axiosCilent.defaults.timeout = 120000;

axiosCilent.interceptors.request.use(async (request) => {
  request.headers = request.headers || {};

  // JWTをsessionStorageから取得
  const token = sessionStorage.getItem("jwt");
  if (token) {
    request.headers['Authorization'] = token;
  } else {
    delete request.headers['Authorization'];
  }

  // JWTは一部のみログ出力
  const tokenPreview = token ? `${token.substring(0, 6)}...` : 'null';
  console.debug(` -- [url] ${request.url} / [token] ${tokenPreview}`);

  return {
    ...request,
  };
});

axiosCilent.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    throw err;
  }
);

export default axiosCilent;
